import React from 'react'
import SbEditable from 'storyblok-react'
import Image from '../atoms/Image'
import Link from '../atoms/Link'

const ContactPersonBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`contact-person-block ${
          block.space_top ? block.space_top : ''
        } ${block.space_bottom ? block.space_bottom : ''}`}
      >
        <div className="contact-person-block-content">
          <div className="row">
            <div className="contact-person-block-image">
              {block.image && (
                <Image
                  imageWidth="750"
                  imageHeight="750"
                  image={block.image}
                  alt={block.name}
                />
              )}
            </div>
            <div className="contact-person-block-text">
              {block.name?.length > 0 && (
                <p className="contact-person-name">{block.name}</p>
              )}
              {block.department?.length > 0 && (
                <p className="contact-person-department">{block.department}</p>
              )}
              {block.tel?.length > 0 && (
                <p className="contact-person-tel">Tel.: {block.tel}</p>
              )}
              {block.fax?.length > 0 && (
                <p className="contact-person-fax">Fax: {block.fax}</p>
              )}
              {block.email?.length > 0 && (
                <p className="contact-person-mail">
                  E-Mail: <Link link={block.email}>{block.email}</Link>
                </p>
              )}
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default ContactPersonBlock
